import React from 'react';
import { sortCaret, headerSortingClasses } from '../../../../helpers';
import { WidgetDate, WidgetTime, WidgetLinkTruncatedText } from '../../../../components';
import { Tooltip, Typography, Button } from '@mui/material';

export default function CancellationsColumns ({ handleClickCancellationConfirm }) {
    return [{
        dataField: 'id',
        text: 'ID',
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses
    }, {
        dataField: 'created_at',
        text: 'Fecha Baja',
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: cellContent => (<WidgetDate date={new Date(cellContent)} />)
    }, {
        dataField: 'created_at_time',
        text: 'Hora',
        sort: false,
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: cellContent => (<WidgetTime date={new Date(cellContent)} />)
    }, {
        dataField: 'metadata.reason',
        text: 'Motivo',
        sort: false,
        align: 'left',
        headerAlign: 'left',
    }, {
        dataField: 'formattedName',
        text: 'Cliente',
        sort: false,
        align: 'left',
        headerAlign: 'left',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => (<WidgetLinkTruncatedText to={`/clients/${row.metadata.id_user}`} text={cellContent} options={{ length: 50 }} />)
    }, {
        dataField: 'type.id',
        text: 'Acciones',
        sort: false,
        align: 'right',
        formatExtraData: { handleClickCancellationConfirm },
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row, rowIndex, { handleClickCancellationConfirm }) => (
            <Tooltip title={<Typography fontSize={10}>Visualizar</Typography>}>
                <span>
                    <Button
                        className='d-flex align-items-center justify-content-center flex-grow-1'
                        style={{ backgroundColor: 'transparent', color: '#F95623', fontSize: '12px', textTransform: 'none' }}
                        onClick={() => handleClickCancellationConfirm(row.id)}
                    >
                Detalle
                    </Button>
                </span>
            </Tooltip>
        )
    }];
}
